import { render, staticRenderFns } from "./schedule-class-form.vue?vue&type=template&id=1b3b2440&scoped=true&"
import script from "./schedule-class-form.vue?vue&type=script&lang=js&"
export * from "./schedule-class-form.vue?vue&type=script&lang=js&"
import style0 from "./schedule-class-form.vue?vue&type=style&index=0&id=1b3b2440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b2440",
  null
  
)

export default component.exports